import Vue from 'vue'
import Router from 'vue-router'
import ShaneBlaser from '@/components/ShaneBlaser'
import SolarGraph from '../components/SolarGraph'
import j2Demo from '../components/j2Demo'
import BootstrapVue from 'bootstrap-vue'

// Gloabal register
Vue.use(Router)
Vue.use(BootstrapVue)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'ShaneBlaser',
      component: ShaneBlaser
    },
    {
      path: '/solarGraph',
      name: 'SolarGraph',
      component: SolarGraph
    },
    {
      path: '/j2Demo',
      name: 'j2Demo',
      component: j2Demo
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js